import NavBar from './NavBar';

export default NavBar;
export { NavBar };
export type { NavBarProps } from './interface';
